import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { LoaderComponent } from './core/components/loader/loader.component';
import { ToastComponent } from './core/components/toast/toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, ToastComponent],

  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'adr-provider-project';
  signedIn: boolean = false;
  constructor() {
    (window as any).versionDate = environment.versionDate;
  }
}
